export const MAX_APP_CONTAINER_WIDTH = '1456px';
export const DEALER_SUPPORT_REQUEST_FORM = 'https://www.dealer.com/support/requestform/';
export const COMMON_CONSUMER_NOT_FOUND_MSG = 'Customer not found on the Common Consumer API';
export const DEALERSHIP_NOT_FOUND_MSG = 'Dealership not found';
export const DEALER_NOT_ASSOCIATED_MSG = 'Dealer is not associated with the dealership';
